'use strict';

exports.__esModule = true;
exports.textShadow = undefined;

var _styledSystem = require('styled-system');

var textShadow = exports.textShadow = (0, _styledSystem.style)({
  prop: 'textShadow',
  key: 'shadows'
});
exports["default"] = (0, _styledSystem.compose)(textShadow, _styledSystem.boxShadow);